"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./slideDown.sass");

var SlideDown =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SlideDown, _React$Component);

  function SlideDown(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, SlideDown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SlideDown).call(this, props, context));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      height: 0,
      animated: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "lastChild", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onTransitionEnd", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          onHide = _this$props.onHide;

      if (!children) {
        _this.setState({
          child: null,
          animated: true
        });

        onHide && onHide();
      } else if (_this.state.animated) {
        _this.setState({
          animated: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onRef", function (element) {
      _this.props.onRef && _this.props.onRef(element);
      _this.element = element;

      if (!element) {
        return;
      }

      var rect = element.getBoundingClientRect();
      var height = rect.height;

      _this.setState({
        height: height,
        animated: true
      });
    });

    if (!props.defaultStateAnimated) {
      _this.state.height = undefined;
      _this.state.animated = false;
    }

    return _this;
  }

  (0, _createClass2.default)(SlideDown, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if (this.element && prevProps.children && !this.props.children) {
        return this.element.getBoundingClientRect().height;
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      if (this.props.children && this.element && this.state.animated) {
        var height = this.element.getBoundingClientRect().height;

        if (height !== this.state.height) {
          // it's a kind of magic. Force browser reflow to run transition over height style
          void this.element.offsetWidth; // Setting new state forces re-render component and run transition
          // eslint-disable-next-line react/no-did-update-set-state

          this.setState({
            height: height
          });
        }
      }

      if (!this.props.children && this.element && snapshot) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          height: snapshot,
          animated: true
        }, function () {
          if (_this2.element) {
            // it's a kind of magic. Force browser reflow to run transition over height style
            void _this2.element.offsetWidth;
          }

          _this2.setState({
            height: 0
          });
        });
      }
    }
  }, {
    key: "getChild",
    value: function getChild() {
      var children = this.props.children;

      if (children) {
        this.lastChild = children;
        return children;
      }

      return this.lastChild;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          popdown = _this$props2.popdown,
          children = _this$props2.children,
          style = _this$props2.style,
          restrictMaxHeight = _this$props2.restrictMaxHeight;
      var _this$state = this.state,
          height = _this$state.height,
          animated = _this$state.animated;
      var child = this.getChild();
      var props = {
        className: (0, _classnames.default)('slideDown', className, {
          'slideDown--active': children && height > 0,
          'slideDown--popdown': popdown,
          'slideDown--animateFinish': !animated,
          'slideDown--restrictMaxHeight': restrictMaxHeight
        }),
        onTransitionEnd: this.onTransitionEnd,
        style: style
      };

      if (animated) {
        props.style = (0, _objectSpread2.default)({}, style, {
          height: height
        });
      }

      return _react.default.createElement("div", props, child && _react.default.createElement("div", {
        className: "slideDown-container",
        ref: this.onRef
      }, child));
    }
  }]);
  return SlideDown;
}(_react.default.Component);

exports.default = SlideDown;
(0, _defineProperty2.default)(SlideDown, "defaultProps", {
  defaultStateAnimated: true
});
SlideDown.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  popdown: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.element]),
  defaultStateAnimated: _propTypes.default.bool,
  onRef: _propTypes.default.func,
  onHide: _propTypes.default.func,
  restrictMaxHeight: _propTypes.default.bool
} : {};